import { createApi } from '@reduxjs/toolkit/dist/query/react';
import baseQueryWithReauth from 'client/util/baseQueryWithReauth';

export const surveyDeliveryApiSlice = createApi({
  reducerPath: 'surveyDeliveryReducer',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['SurveyDelivery'],
  endpoints: builder => ({
    getDeliveryMetrics: builder.query({
      query: ({ survey, channel, since, until, saved_search_id: savedSearchId }) => ({
        url: `/surveys/${survey}/delivery-metrics`,
        params: {
          channel,
          since,
          until,
          ...(savedSearchId ? { saved_search_id: savedSearchId } : {}),
        },
      }),
      providesTags: ['SurveyDelivery'],
    }),
    getDeliveryTimeSeries: builder.query({
      query: ({
        survey,
        channel,
        since,
        until,
        interval,
        time_zone: timeZone,
        saved_search_id: savedSearchId,
      }) => ({
        url: `/surveys/${survey}/delivery-metrics/time-series`,
        params: {
          channel,
          since,
          until,
          interval,
          ...(timeZone ? { time_zone: timeZone } : {}),
          ...(savedSearchId ? { saved_search_id: savedSearchId } : {}),
        },
      }),
      providesTags: ['SurveyDelivery'],
    }),
    getDeliveryMetricsAllChannels: builder.query({
      query: ({ survey, since, until }) => ({
        url: `/surveys/${survey}/delivery-metrics/all`,
        params: { since, until },
      }),
      providesTags: ['SurveyDelivery'],
    }),
  }),
});

export const {
  useGetDeliveryMetricsQuery,
  useGetDeliveryTimeSeriesQuery,
  useGetDeliveryMetricsAllChannelsQuery,
  reducer: surveyDeliveryReducer,
} = surveyDeliveryApiSlice;
